export function initCostEstimatorBlocks() {
	const controls = document.querySelectorAll('[data-ce-size]');
	if (!controls.length) {
		return;
	}

	controls.forEach((control) => {
		const select = control.querySelector('select');
		const minusButton = control.querySelector('[data-ce-minus]');
		const plusButton = control.querySelector('[data-ce-plus]');

		if (!(select instanceof HTMLSelectElement)) {
			return;
		}

		if (minusButton instanceof HTMLButtonElement) {
			minusButton.addEventListener('click', () => {
				shiftSelectOption(select, -1);
			});
		}

		if (plusButton instanceof HTMLButtonElement) {
			plusButton.addEventListener('click', () => {
				shiftSelectOption(select, 1);
			});
		}
	});
}

function shiftSelectOption(select, direction) {
	const optionsCount = select.options.length;
	if (optionsCount <= 1) {
		return;
	}

	const currentIndex = Math.max(0, select.selectedIndex);
	const nextIndex = Math.min(optionsCount - 1, Math.max(0, currentIndex + direction));
	if (nextIndex === currentIndex) {
		return;
	}

	select.selectedIndex = nextIndex;
	select.dispatchEvent(new Event('change', { bubbles: true }));
}
